export default "__VITE_ASSET__DV82P7oc__"